import apiConfig from 'constants/apiConfig';
import { CampaignInvites } from 'types/campaign/invites';
import axiosClient from 'utils/axiosClient';

export const fetchInvites = async (filters: Record<string, unknown> = {}): Promise<CampaignInvites> => {
    const response = await axiosClient.get(apiConfig.FETCH_INVITES.url, { params: filters });
    return response.data;
};
